import Grid from "@mui/material/Grid2";
import DataContainer from "../../../Utilities/DataContainer";
import ValidatedTextField from "../../../Utilities/Forms/ValidatedTextField";
import { useContext } from "react";
import { SessionContext } from "../../../Contexts/SessionContext";
import { InputLabel } from "@mui/material";

interface IProps { isReadOnly: boolean; }
export default function Comments({ isReadOnly }: IProps) {
    const { sessionState } = useContext(SessionContext);
    return (
        <DataContainer title="Comments">
            <Grid size={12}>
                <ValidatedTextField name={'comments'} readOnly={isReadOnly} multiline={true} rows={5} />
            </Grid>
            {sessionState.siteListMain == '17' &&
                <Grid size={12}>
                    <InputLabel style={{ color: 'black' }}>Details of non-residential land uses within the site</InputLabel>
                    <ValidatedTextField name={'detailsOfNonResidentialLandUses'} readOnly={isReadOnly} multiline={true} rows={5} />
                </Grid>
            }
        </DataContainer >
    );
}